import { Box, Stack, Typography } from '@mui/material';

export interface LogoProps {
  readonly buildSha: string;
  readonly collapsed?: boolean;
}

export function Logo({ buildSha, collapsed = false }: LogoProps) {
  return (
    <Stack
      aria-label="AGAF BackOffice"
      direction="row"
      role="group"
      spacing={1.5}
      sx={{ alignItems: 'center', minHeight: 48, overflow: 'hidden' }}
      title={collapsed ? buildSha : undefined}
    >
      <Box
        aria-hidden="true"
        sx={{
          display: 'grid',
          filter: 'drop-shadow(0 5px 8px rgba(31, 111, 235, 0.22))',
          flex: '0 0 54px',
          height: 48,
          placeItems: 'center',
          width: 54,
        }}
      >
        <Box
          component="svg"
          data-testid="agaf-monogram"
          focusable="false"
          sx={{ height: 48, overflow: 'visible', width: 55 }}
          viewBox="0 0 64 56"
        >
          <Box
            component="path"
            d="M18 52 38 4h10l16 48H53l-5-14H30l-6 14H18Zm15-23h12L40 14 33 29Z"
            data-layer="accent"
            fill="var(--aurora-palette-iconTint-blue-foreground)"
            fillRule="evenodd"
          />
          <Box
            component="path"
            d="M2 52 22 4h10l20 48H41l-6-14H17l-6 14H2Zm19-23h11l-5-15-6 15Z"
            data-layer="foreground"
            fill="var(--aurora-palette-primary-main)"
            fillRule="evenodd"
          />
        </Box>
      </Box>
      {!collapsed ? (
        <Stack spacing={0.125} sx={{ minWidth: 0 }}>
          <Typography
            noWrap
            sx={{ fontSize: '1.2rem', fontWeight: 900, letterSpacing: '0.12em', lineHeight: 1.25 }}
          >
            Affiliate
          </Typography>
          <Typography
            color="text.secondary"
            noWrap
            sx={{ fontSize: '0.82rem', letterSpacing: '0.01em', lineHeight: 1.2 }}
          >
            BackOffice
          </Typography>
        </Stack>
      ) : null}
    </Stack>
  );
}
